import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormGroup } from "@angular/forms";

@Component({
    selector: "clare-checkbox",
    templateUrl: "./clare-checkbox.component.html",
    styles: [
        `
            .label {
                text-align: left;
            }
        `,
    ],
})
export class ClareCheckboxComponent implements OnInit {
    @Input() metaData: any;
    @Input() theForm: FormGroup;
    @Input() isRequired = false;

    ngOnInit() {
        this.theForm.patchValue({ [this.metaData.inputName]: this.metaData.valuesArray });
        if (this.isRequired) {
            this.theForm.controls[this.metaData.inputName].setValidators([this.atLeastOneCheckboxChecked()]);
        }
    }

    atLeastOneCheckboxChecked() {
        return (formArray: FormArray) => (formArray?.value?.some((control: any) => control.checked === true) ? null : { required: true });
    }

    onCheck(event, index) {
        this.metaData.valuesArray[index].checked = event.checked;
        this.theForm.patchValue({ [this.metaData.inputName]: this.metaData.valuesArray });
        this.theForm.updateValueAndValidity();
    }

    onCheckAll() {
        const valuesArrayLength = this.metaData.valuesArray.length;
        for (let i = 0; i < valuesArrayLength; i++) {
            this.metaData.valuesArray[i].checked = true;
        }
        this.theForm.patchValue({ [this.metaData.inputName]: this.metaData.valuesArray });
        this.theForm.updateValueAndValidity();
    }
}
